import { user } from "./store";

export function userAllowed(permission) {
    return user.value.scopes.includes(permission)
}